import React, { useState, useEffect, useRef } from "react";
import { captureSubmissionError } from "../../utils/sentryUtils";
import SubmittingCard from "../../components/SubmittingCard";
import SubmissionErrorCard from "../../components/SubmissionErrorCard";

const MoreInformationSubmission = ({ moreInformationFlowState: flowState, onFlowComplete }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ref guard prevents StrictMode double-mount from firing a second request
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    const isEmptySubmission =
      flowState.client == null &&
      flowState.sellerIsRegisteredOwner == null &&
      flowState.registeredOwner == null &&
      flowState.registeredOwnerDetails == null &&
      flowState.lawFirmHandlingProbate == null &&
      flowState.employmentInformation == null;

    if (isEmptySubmission) {
      setError("No information provided");
      setLoading(false);
      return;
    }

    fetch("/api/moreInformation", {
      method: "PUT",
      body: JSON.stringify({
        formRequestId: flowState.formRequestId,
        transactionType: flowState.transactionType,
        client: flowState.client,
        sellerIsRegisteredOwner: flowState.sellerIsRegisteredOwner,
        registeredOwner: flowState.registeredOwner,
        registeredOwnerDetails: flowState.registeredOwnerDetails,
        lawFirmHandlingProbate: flowState.lawFirmHandlingProbate,
        employmentInformation: flowState.employmentInformation,
      }),
    })
      .then(
        async (resp) => {
          if (resp.ok) {
            setLoading(false);
            onFlowComplete();
          } else {
            const body = await resp.text().catch(() => "");
            console.error("More information submission failed:", resp.status, body);
            captureSubmissionError("MoreInformation", resp.status, body);
            setError("Unable to process your details");
            setLoading(false);
          }
        },
        (err) => {
          console.error("More information submission failed:", err);
          setError("Unable to process your details");
          setLoading(false);
        },
      )
      .catch((err) => {
        console.error("More information submission failed:", err);
        setError("Unable to process your details");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- submit once on mount; ref guard prevents StrictMode re-fire

  if (loading) {
    return <SubmittingCard />;
  }

  if (error) {
    return <SubmissionErrorCard error={error} />;
  }

  return null;
};

export default MoreInformationSubmission;
